// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".megamenu-image-wrapper[data-v-745cdcce]{height:100%;margin-left:-1.25rem;margin-right:-1.25rem}@media (min-width:992px){.megamenu-image-wrapper[data-v-745cdcce]{margin-left:0;margin-right:0}}@media (max-width:992px){.megamenu-image-wrapper[data-v-745cdcce]{min-height:200px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
